module.exports = __webpack_public_path__ + "static/media/asesoria.96ee67af.png";